module.exports = __webpack_public_path__ + "img/avatar.79c8d028.png";